/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateCampaignWhatsAppAutomationDataSchema = z.object({
	enabled: z.boolean().nullable().optional(),
	scoreThreshold: z.number().nullable().optional(),
})

export type UpdateCampaignWhatsAppAutomationDataSchema = z.infer<typeof updateCampaignWhatsAppAutomationDataSchema>
